import ng from 'angular';
import { Component, Input } from 'angular-ts-decorators';

import { IGroupRetailer } from '@gn-audio/core/api/retailers/models';

import template from './retailer-locator.component.html';

@Component({
  selector: 'retailerLocator',
  template,
})
export class RetailerLocatorComponent implements ng.IController {
  @Input() public readonly retailers: IGroupRetailer[];
  
  public areRetailersVisible = false;

  public $onChanges(): void {
    this.areRetailersVisible = false;
  }

  public toggleRetailersVisibility() {
    this.areRetailersVisible = !this.areRetailersVisible;
  }
}
